module.exports = __webpack_public_path__ + "static/cta-border-shape-a73894e4aed6336554a4193d410ff78e.png";